import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProcessoHistoricoComponent } from './processo-historico/processo-historico.component';
import { ProcessoListaComponent } from './processo-lista/processo-lista.component';

const routes: Routes = [
  { path: 'processo/listar', component: ProcessoListaComponent, data: { titulo: 'Lista de processos' }},
  { path: 'processo/historico/:id', component: ProcessoHistoricoComponent, data: { titulo: 'Histórico do Processo' }},
  { path: 'processo/historico/:fonteDados/:origemId', component: ProcessoHistoricoComponent, data: { titulo: 'Histórico do Processo' }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProcessoRoutingModule { }
